module.exports = __webpack_public_path__ + "static/media/support-station-photo-03.be3faa24.jpg";